// extracted by mini-css-extract-plugin
export default {"avatar_filled":"HeaderNav_avatar_filled__dTQmx","headerNav":"HeaderNav_headerNav__mYRmK","logo":"HeaderNav_logo__DNKEx","navbar":"HeaderNav_navbar__7rL+P"};